export var QUERY_MOBILE_LANDSCAPE = '@media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (orientation: landscape)';